import React from 'react';

import { InputLabel, Menu, Stack } from '@mui/material';

import Picker from './Picker';
import TriggerButton from './TriggerButton';

type Props = {
  label: string;
  onChange: (value: string | null) => void;
  value: string;
  secondarySwatch: string[];
  disableReset?: boolean;
};
export default function RawColorPickerInput({ label, onChange, value, disableReset, secondarySwatch }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  return (
    <Stack alignItems="flex-start">
      <InputLabel sx={{ mb: 0.5 }}>{label}</InputLabel>
      <TriggerButton setAnchorEl={setAnchorEl} value={value} disableReset={Boolean(disableReset)} onChange={onChange} />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          sx: { height: 'auto', padding: 0 },
        }}
      >
        <Picker value={value} onChange={onChange} secondarySwatch={secondarySwatch} />
      </Menu>
    </Stack>
  );
}
